import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/** @jsx jsx */
import Button from '@datacamp/waffles-button';
import { Checkbox, CheckboxList, TextArea } from '@datacamp/waffles-form-elements';
import { Dialog } from '@datacamp/waffles-modals';
import { css, jsx } from '@emotion/react';
import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from '../../useTranslation';

var constructFeedbackMessage = function constructFeedbackMessage(values, otherValue) {
  if (values.length > 0) {
    var checkboxString = "Checkboxes: - ".concat(values.join('; - '));

    if (otherValue && values.includes('Other')) {
      return "".concat(checkboxString, ";\nAdditional feedback: ").concat(otherValue);
    }

    return "".concat(checkboxString, ";");
  }

  return '';
};

var RatingDialog = function RatingDialog(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      onSubmit = _ref.onSubmit;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      values = _useState2[0],
      setValues = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      otherValue = _useState4[0],
      setOtherValue = _useState4[1];

  var isOtherSelected = useMemo(function () {
    return values.includes(t('AiAssistantRatingDialog.checkboxOther'));
  }, [values, t]);
  var checkboxes = [t('AiAssistantRatingDialog.checkboxIncorrect'), t('AiAssistantRatingDialog.checkboxSlow'), t('AiAssistantRatingDialog.checkboxHardToUnderstand'), t('AiAssistantRatingDialog.checkboxUnrelated'), t('AiAssistantRatingDialog.checkboxIncorrectSolution'), t('AiAssistantRatingDialog.checkboxImproperDisplay'), t('AiAssistantRatingDialog.checkboxOther')];
  var onClick = useCallback(function () {
    var message = constructFeedbackMessage(values, otherValue);
    onSubmit(message);
  }, [onSubmit, otherValue, values]);
  return jsx(Dialog, {
    isOpen: isOpen,
    onClose: onClose,
    width: 500
  }, jsx(Dialog.Header, null, t('AiAssistantRatingDialog.header')), jsx("form", {
    id: "prediction-feedback-form",
    name: "prediction-feedback-form"
  }, jsx(Dialog.Body, null, jsx("div", {
    css: css({
      display: 'flex',
      flexDirection: 'column',
      gap: 16
    })
  }, jsx(CheckboxList, {
    label: t('AiAssistantRatingDialog.checkboxListLabel'),
    name: "prediction-checkboxes",
    onChange: setValues,
    value: values
  }, checkboxes.map(function (checkbox) {
    return jsx(Checkbox, {
      key: checkbox,
      value: checkbox
    }, checkbox);
  })), isOtherSelected && jsx(TextArea, {
    name: "prediction-other",
    onChange: setOtherValue,
    value: otherValue
  }))), jsx(Dialog.Footer, null, jsx(Button, {
    appearance: "primary",
    dataAttributes: {
      cy: 'ai-assistant-submit-negative-feedback'
    },
    disabled: values.length === 0,
    intent: "success",
    onClick: onClick
  }, t('AiAssistantRatingDialog.primaryButton')))));
};

export default RatingDialog;